import React, {useState} from 'react';
import TextInput from '../../common/component/form/TextInput';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {login} from '../action/accountActions';
import '../style/Login.less';
import {Redirect} from 'react-router';
import {createErrorMessage, handleEmailChange} from '../util/AccountUtil';
import {Link, useHistory} from 'react-router-dom';
import ErrorCode from '../../common/enums/ErrorCode';

function Login() {
    const history = useHistory();
    const isLoggedIn = useSelector(state => state.account.isLoggedIn);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [validation, setValidation] = useState({
        email: true,
        password: true
    });
    const [t] = useTranslation();
    const dispatch = useDispatch();
    const [loginError, setLoginError] = useState();

    if (isLoggedIn) {
        return <Redirect to={{pathname: '/'}}/>;
    }

    function isValid() {
        const newValidation = {
            email: !!email,
            password: !!password
        };
        setValidation(newValidation);
        return Object.values(newValidation).every(field => !!field);
    }

    function handleLogin() {
        setLoginError(null);
        if (isValid()) {
            dispatch(login(email, password, (response) => {
                if (response.errorCode === ErrorCode.INVALID_AUTHENTICATION.code) {
                    setLoginError(response.errorCode);
                }
            }));
        }
    }

    function handlePasswordReset() {
        history.push('/request-password-reset');
    }

    return (
        <>
            <div className="login-wrapper">
                <div className="mr-4 ml-4">
                    <div className="card">
                        <div className="card-body big-label">
                            <h1>{t('Login.WELCOME')}</h1>
                            <form onSubmit={e => {
                                e.preventDefault();
                                handleLogin();
                            }}
                            >
                                <TextInput
                                    id="username"
                                    value={email}
                                    label={t('Login.EMAIL')}
                                    onChange={(value) => {
                                        handleEmailChange(value, setEmail, setLoginError);
                                    }}
                                    required={true}
                                    isValid={validation.email && !loginError}
                                    focusOnLoad={true}
                                    autoComplete="email"
                                    errorMessage={createErrorMessage(loginError)}
                                />
                                <TextInput
                                    id="password"
                                    value={password}
                                    label={t('Login.PASSWORD')}
                                    type="password"
                                    onChange={setPassword}
                                    required={true}
                                    isValid={validation.password}
                                    autoComplete="password"
                                />
                                <div className="small">
                                    <a href="#" onClick={handlePasswordReset}>{t('Login.PASSWORD_RESET')}</a>
                                </div>
                                <div className="align-right">
                                    <button type="submit" className="btn btn-primary mt-4">
                                        {t('Login.LOGIN')}
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div className="mb-5 ml-4">
                            {t('Login.NEW')} <Link to="/register">{t('Login.REGISTER_HERE')}</Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Login;
